import globalConfigQuery from '~/gql/globalConfig.gql'

function parseConfigItems (configItems) {
  return configItems.reduce((acc, configItem) => {
    if (configItem.type === 'string') {
      configItem.value = configItem.valueString
    } else if (configItem.type === 'boolean') {
      configItem.value = configItem.valueBoolean
    } else if (configItem.type === 'int') {
      configItem.value = configItem.valueInt
    } else if (configItem.type === 'float') {
      configItem.value = configItem.valueFloat
    } else if (configItem.type === 'date') {
      configItem.value = configItem.valueDate
    } else if (configItem.type === 'datetime') {
      configItem.value = configItem.valueDatetime
    } else if (configItem.type === 'json') {
      configItem.value = configItem.valueJson
    } else {
      console.error('Unknown config item type', configItem)
    }

    acc[configItem.slug] = configItem.value
    return acc
  }, {})
}

export const useGlobalConfigStore = defineStore('globalConfig', {
  state: () => ({
    featureFlags: [],
    configItems: []
  }),

  actions: {
    async getGlobalConfig() {
      const { localeForDato } = useDatoLocale()
      const { $sentry } = useNuxtApp()

      try {
        const { data: response, error } = await useDatoQuery({
          query: globalConfigQuery,
          prefetchedRequest: 'globalConfig',
          variables: {
            slug: localeForDato,
          },
        })

        if(error.value) {
          throw error
        }

        this.featureFlags = response.value.globalConfig.flags
        this.configItems = parseConfigItems(
          response.value.globalConfig.configItems
        )
      } catch(fetchError) {
        $sentry.captureException(fetchError)
      }
    },
  },

  getters: {
    isFlagEnabled: (state) => (flagId) => {
      if (!state.featureFlags.length) return false

      return state.featureFlags.some(
        (featureFlag) => featureFlag.flagId === flagId && featureFlag.enabled
      )
    },
    getConfig: (state) => (configSlug) => {
      return state.configItems[configSlug]
    }
  }
})
